// EmployeeManagementEmbed strings — EN + TR.
//
// Wave-2 Day 2. Cattr iframe wrapper with installer dropdown (Windows / macOS
// / Linux). 104 LOC source file had EN installer labels + TR chrome
// ("gömülü görünüm" / "Yeni sekmede aç") per i18n audit 2026-06-02
// (commit ca624ba).
//
// Embed chrome (`gömülü görünüm` + `Yeni sekmede aç`) lives here; lift it to a
// shared embed chrome dict if another iframe wrapper ever needs it.
//
// Source: components/EmployeeManagementEmbed.tsx.

import type { LocalizedDict } from '../index'

type EmployeeManagementEmbedStrings = {
  title: string
  embeddedView: string
  openNewTab: string
  downloadDesktopApp: string
  recommended: string
  installers: {
    windowsInstaller: string
    windowsPortable: string
    macIntelSilicon: string
    linuxAppImage: string
    linuxDebUbuntu: string
    linuxTarball: string
  }
}

export const employeeManagementEmbedI18n: LocalizedDict<EmployeeManagementEmbedStrings> = {
  en: {
    title: 'Employee Management (Cattr)',
    embeddedView: '— embedded view',
    openNewTab: 'Open in new tab',
    downloadDesktopApp: 'Download Desktop App',
    recommended: 'recommended',
    installers: {
      windowsInstaller: 'Windows (installer)',
      windowsPortable: 'Windows (portable)',
      macIntelSilicon: 'macOS (Intel + Apple Silicon)',
      linuxAppImage: 'Linux (AppImage)',
      linuxDebUbuntu: 'Linux (Debian / Ubuntu .deb)',
      linuxTarball: 'Linux (tarball)',
    },
  },
  tr: {
    title: 'Çalışan Yönetimi (Cattr)',
    embeddedView: '— gömülü görünüm',
    openNewTab: 'Yeni sekmede aç',
    downloadDesktopApp: 'Masaüstü Uygulamasını İndir',
    recommended: 'önerilen',
    installers: {
      windowsInstaller: 'Windows (kurulum)',
      windowsPortable: 'Windows (taşınabilir)',
      macIntelSilicon: 'macOS (Intel + Apple Silicon)',
      linuxAppImage: 'Linux (AppImage)',
      linuxDebUbuntu: 'Linux (Debian / Ubuntu .deb)',
      linuxTarball: 'Linux (tar.gz arşivi)',
    },
  },
}
